module.exports = "/images/fp_optimizer_mockup.svg?d47ae2736cfa15090dffa9c315e2b58e";